import { cn } from "@lib/cn";
import { dialogStyles as styles } from "@modules/slides-library/shared";
import { useMemo } from "react";

const SavedSkeleton = () => <></>;

const Slides = ({ count = 6 }: { count?: number }) => {
  const slides = useMemo(
    () => Array.from({ length: count }, (_, index) => index),
    [count],
  );

  return (
    <>
      {slides.map((item) => (
        <div className="tw-animate-skeleton-loading" key={item}>
          <span className="tw-block tw-h-32 tw-rounded-lg tw-bg-blue-100"></span>
          <span className="tw-mt-3 tw-block tw-h-[6px] tw-w-20 tw-rounded-2xl tw-bg-blue-100"></span>
        </div>
      ))}
    </>
  );
};

const Folders = () => {
  return (
    <>
      {[1, 2, 3, 4].map((item) => {
        return (
          <div
            className={cn(
              "tw-flex tw-h-12 tw-animate-skeleton-loading tw-items-center tw-rounded-lg tw-border tw-border-solid tw-border-blue-100 tw-bg-white tw-p-3",
              styles["saved-slides-shadow"],
            )}
            key={item}
          >
            <span className="tw-mr-3 tw-block tw-size-4 tw-rounded-full tw-bg-blue-100"></span>
            <span className="tw-block tw-h-[6px] tw-w-28 tw-rounded-2xl tw-bg-blue-100"></span>
          </div>
        );
      })}
    </>
  );
};

const SIDEBAR_WIDTHS = [65, 80, 45];

const Sidebar = () => {
  return (
    <div className="tw-animate-skeleton-loading tw-space-y-2 tw-p-3">
      <div className="tw-flex tw-h-8 tw-animate-skeleton-loading tw-items-center tw-rounded-md tw-px-3">
        <span className="tw-mr-2 tw-flex tw-size-4 tw-rounded-full tw-bg-blue-100"></span>
        <span className="tw-block tw-h-[6px] tw-w-36 tw-rounded-2xl tw-bg-blue-100"></span>
      </div>
      {SIDEBAR_WIDTHS.map((item) => (
        <div
          className="tw-flex tw-h-[30px] tw-items-center tw-px-3 tw-pl-9"
          key={item}
        >
          <span
            className="tw-h-[6px] tw-rounded-2xl tw-bg-blue-100"
            style={{ width: `${item}%` }}
          ></span>
        </div>
      ))}
      <div className="tw-flex tw-h-8 tw-animate-skeleton-loading tw-items-center tw-rounded-md tw-px-3">
        <span className="tw-mr-2 tw-flex tw-size-4 tw-rounded-full tw-bg-blue-100"></span>
        <span className="tw-block tw-h-[6px] tw-w-36 tw-rounded-2xl tw-bg-blue-100"></span>
      </div>
    </div>
  );
};

SavedSkeleton.Sidebar = Sidebar;
SavedSkeleton.Slides = Slides;
SavedSkeleton.Folders = Folders;

export { SavedSkeleton };
